import React from "react";
import { PromptModal } from "@/components/Common/PromptModal";
import { ConfirmationModalProps, useConfirmationModal } from "@/hooks/useConfirmationModal";

export const useEditWindowConfirmationModal = () => {
    const { ConfirmationModal, confirm, withConfirmation } = useConfirmationModal(EditWindowConfirmationModal);

    return {
        EditWindowConfirmationModal: ConfirmationModal,
        confirmEditWindow: confirm,
        withEditWindowConfirmation: withConfirmation,
    };
};

type EditWindowConfirmationModalProps = ConfirmationModalProps;

const EditWindowConfirmationModal = ({ isOpen, onClose, onContinue }: EditWindowConfirmationModalProps) => {
    return (
        <PromptModal
            color="primary"
            title="Warning: Applies to Past Purchases"
            isOpen={isOpen}
            onConfirm={onContinue}
            onClose={onClose}
        >
            <span>
                This change will also apply to all past purchases of this experience. Would you like to continue?
            </span>
        </PromptModal>
    );
};
